import React from 'react';
import { Box, Divider } from '@mui/material';
export default function HorizontalRule() {
    return (React.createElement(Box, { sx: { flexGrow: 1, marginTop: 4, marginBottom: 2 } },
        React.createElement(Divider, null)));
}
